const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class CrimeWave extends Event {
    constructor(){
        super(
            Age.Age2,
            EventNames.CrimeWave,
            "The two weakest civilizations lose 3 culture and return 1 blue token to the box.",
            {}
        )
    }
}

module.exports = CrimeWave;